module.exports = __webpack_public_path__ + "media/images/landing/illust/sample-0ac06c93965a18db2735c6b000de745b.jpg";